'use client';

import React, { useState, useEffect } from 'react';

export default function WeeklySchedule({ entries = [] }) {
  const days = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
  const [activeDay, setActiveDay] = useState('');

  useEffect(() => {
    const todayIndex = new Date().getDay(); 
    const adjustedIndex = todayIndex === 0 ? 6 : todayIndex - 1;
    setActiveDay(days[adjustedIndex]);
  }, []);

  const groupedEntries = days.reduce((acc, day) => {
    acc[day] = entries.filter(entry => (entry.Day || entry.attributes?.Day) === day);
    acc[day].sort((a, b) => (a.Time_Start > b.Time_Start ? 1 : -1));
    return acc;
  }, {});

  if (!entries || entries.length === 0) return null;

  return (
    <div className="schedule-tabs-container">
      {/* Die Tab-Leiste */}
      <div className="days-nav">
        {days.map((day) => (
          <button
            key={day}
            className={`day-tab ${activeDay === day ? 'active' : ''}`}
            onClick={() => setActiveDay(day)}
          >
            {day}
          </button>
        ))}
      </div>

      {/* Die Kursliste */}
      <div className="active-day-content">
        <h2 className="current-day-title">{activeDay}</h2>
        <div className="kurs-liste-vertical">
          {groupedEntries[activeDay]?.map((item) => {
            const d = item.attributes || item;
            const instructor = d.instructor;
            const instId = instructor?.documentId || instructor?.id;

            return (
              <div key={item.id} className="schedule-row">
                <div className="schedule-time">
                  {d.Time_Start?.slice(0, 5)} - {d.Time_End?.slice(0, 5)}
                </div>

                <div className="schedule-details">
                  <div className="schedule-course-name">
                    {d.Service?.Service_Slug ? (
                      <a href={`/angebote#${d.Service.Service_Slug}`}>
                        {d.Course_Title || d.Service.Service_Title}
                      </a>
                    ) : (
                      <span>{d.Course_Title || d.Service?.Service_Title || "Kurs"}</span>
                    )}
                  </div>
                  {d.Audience && (
                    <div className="schedule-audience">
                      Zielgruppe / Spezialthema: {d.Audience}
                    </div>
                  )}
                  {/* Angepasst auf das Feld 'Teacher' */}
                  {d.Teacher && (
                    <div className="schedule-instructor">
                      mit {(() => {
                        const t = d.Teacher;
                        const name = t.Team_Name || t.Name;
                        
                        // Wir suchen zuerst nach dem Team_Slug. Nur wenn der (warum auch immer) fehlt, 
                        // nehmen wir als Notlösung die documentId.
                        const slug = t.Team_Slug || t.documentId || t.id;
                        
                        return slug ? (
                          <a href={`/team#${slug}`}>{name}</a>
                        ) : (
                          <span>{name}</span>
                        );
                      })()}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}